<div class="billiai" [ngClass]="{'sticky': stickyFlag}">
    <div class="sticky-position" id="asc">
        <i data-aos="zoom-out-up" data-aos-duration="1000"></i> 
    </div>
    <h1 id="intro">· 소개</h1>
    <em>빌리아이는 대전, 연습, 학습이 가능한 당구 시스템으로서 카메라, 빔프로젝트, 당구대 켈리브레이션 기술,
        실시간 당구공, 큐대의 정밀 좌표 인식, 공역학까지 집약적인 기술력과 꾸준한 연구로 만들어졌습니다. 이러한 고도 기술력의
        빌리아이는 자동점수판독, 예측경로, 추천경로, 공위치 반복학습, 경로 분석과 같은 기능들을 사용할 수 있으며, 당구의
        원격 대전까지 가능케하는 인공지능 AR 당구 기술을 선도하는 시스템입니다. </em>
    <div class="function">
        
        <div class="section">
            <h1>· 구성도</h1>
            <img src="/assets/images/billiai/01.png">
        </div>
        <h1>· 주요기능</h1>
        <div class="section">
            <h4>1. 자동점수판정 시스템</h4>
            <em> 타구 시에 움직이는 공들의 좌표 정보를 인공지능으로 분석하여 성공 여부를 자동 판정하는 시스템 </em> 
            <img  src="/assets/images/billiai/02.png">
        </div>
        <div class="section">
            <h4>2. 예측경로</h4>
            <em> 내 공과 큐대 방향을 AI알고리즘과 시뮬레이션을 통해 실시간으로 예측된 경로를 표시 </em> <img
                src="/assets/images/billiai/06.GIF">
        </div>
        <div class="section">
            <h4>3. 추천경로</h4>
            <em> 공들의 위치 정보를 기반으로 AI알고리즘을 활용하여 최적의 경로를 당구대 위에 표시하는 기능 </em> 
            <img src="/assets/images/billiai/05.png">
        </div>
        <div class="section">
            <h4>4. 공 위치 반복 학습</h4>
            <em> • 타구 한 공들의 시작 위치를 기억하여 반복 학습하는 기능 <br> • 공들을 원하는
                위치에 지정하여 반복 학습하는 기능
            </em> <img src="/assets/images/billiai/03.png">
        </div>
        <div class="section">
            <h4>5. 경로 분석</h4>
            <em> • 타구의 타점, 힘, 스핀, 속도와 적구의 두께를 분석하는 기능 </em> <img
                src="/assets/images/billiai/04.png">
        </div>
    </div>
</div>